import { defineMessages } from 'react-intl';

export default defineMessages({
    address: {
        id: 'endorsement.ba.directives.templates.ba-address-change-edit.Address',
        defaultMessage: 'Address',
    },
    garageAddress: {
        id: 'endorsement.common.views.change-address.ba.Garage Address Label',
        defaultMessage: 'Apply this address as the garaging address for all the vehicles?',
    },
    toggleYes: {
        id: 'endorsement.ba.views.Yes',
        defaultMessage: 'Yes',
    },
    toggleNo: {
        id: 'endorsement.ba.views.No',
        defaultMessage: 'No',
    },
    effectiveDate: {
        id: 'endorsement.ba.policy-info.Effective Date',
        defaultMessage: 'Effective Date'
    },
    expirationDate: {
        id: 'endorsement.ba.policy-info.Expiration Date',
        defaultMessage: 'Expiration Date'
    }
});
